export default "__VITE_ASSET__B3lBDWQG__"